/**
 * **전사 공지 저작** — 슈퍼관리자가 전 고객(또는 고른 조직)에게 보일 공지를 쓰는 자리.
 *
 * 줄기 `popup-and-announcement-surface` **P3-u**. 서버는 2026-10-19에 섰고(`P3-s`) 이 화면이
 * 그 저작 경로의 **유일한 진입점**이다. 계약 정본은 `lib/announcements.ts`와 서버
 * `AdminAnnouncementsController` JSDoc.
 *
 * ## 공지는 **게시판**이고 팝업은 그것이 부르는 기제다
 *
 * 결정 `2026-10-15-announcement-is-a-board-and-popup-is-a-mechanism-it-calls.md` — 공지는 지난 것을
 * 다시 볼 수 있어야 하고(보존), 팝업은 **선택 병행**(노출)이다. 그래서 이 화면의 목록은
 * **초안·숨김·만료를 전부** 보인다(서버 `listCompanyWide`가 그 전수를 돌려준다) — 「노출 후보」로
 * 읽지 말 것. 노출 판정은 **다른 쿼리**이고 서버가 메서드로 갈라 두었다(`listBoard` ∥ 이것).
 *
 * ## ⚠️ 알림 발송(`/message-send`)과 **다른 일**이다 — 합치지 말 것
 *
 * `POST /admin/notifications/send`(`targetType:'all'`)는 **사람마다 한 행**을 만들므로 ⓐ 나중에
 * 가입한 사람은 지난 공지를 **볼 수 없고** ⓑ `isRead`로 묻힌다. 게시판은 **글 하나 + 본 사람
 * 기록**이다(2026-10-15 측정으로 가른 셋 — 줄기 P3-u 절). 둘은 서로를 대체하지 않는다.
 *
 * ## ⭐ 세 가드를 **자기 허용 집합으로 다시 계산했다** (`ORG_POPUP_PLATFORMS` JSDoc의 지시)
 *
 * 조직 저작 경로는 `ADMIN` surface를 **애초에 받지 않아** 두 역할 체계에 걸치는 상태가 구조적으로
 * 없다. **이 경로는 `ADMIN`을 받으므로 그 상태가 표현 가능해진다** ⇒ 셋을 각각 판정했고 **결론이
 * 갈린다**:
 *
 * | 가드 | 집행 자리 | 왜 |
 * |---|---|---|
 * | ③④ `orgScope != ALL` × `ADMIN` | **이 화면이 선제 차단** | 두 값만 보면 되고 **매핑이 필요 없다** |
 * | ⑤ `orgScope` ↔ 타깃 짝 | **이 화면의 형상이 보장** | 모드가 라디오이고 `ALL`이면 목록을 렌더하지 않는다 |
 * | 닿지 않는 체계(dangling) | **서버 하나** | 매핑이 서버에만 있다 — 아래 |
 * | 한쪽만 좁혔다(unconstrained) | **서버 주도 승인** | 같은 이유 — 아래 |
 *
 * ⚠️ **뒤의 둘에 선제 차단이 «없는 것»은 빠뜨린 것이 아니라 결정이다 — 결함으로 읽지 말 것.**
 * 사유·되짚을 조건·그 대가의 정본은 **`lib/announcements.ts`의 `ANNOUNCEMENT_UNCONSTRAINED_CODE`
 * JSDoc 한 벌**이고, 그 결정의 선례 자리는 `components/ReleaseNoteAudienceModal.tsx` docblock의
 * 「⚠️ 「닿지 않는 체계를 제약했다」는 서버가 거부한다」 절이다. **여기 본문을 베끼지 않는다** —
 * 베끼면 두 벌이 되어 한쪽이 낡는다(팀장 요구 2026-10-20).
 *
 * 요지 셋만: ⓐ 매핑(`impliedNamespaces`)이 **서버에만** 있어 admin이 읽을 수 없고, 베끼면 같은
 * 규약의 두 번째 구현이 된다 ⓑ 선례의 클라이언트측 근사(역할 그룹 **전체**를 「닿는 체계」로 봄)는
 * 이 화면에서 **거짓 승인 요구**가 된다(`WEB`만 고른 공지에 「슈퍼관리자 전원에게 보여도
 * 됩니까」를 묻는다 — 그들은 그 공지를 아예 못 본다) ⓒ **그 대가로 그 조합을 쓰는 운영자는 왕복을
 * 한 번 더 돈다**(첫 전송이 400을 받는다). 그것이 **의도된 거래**다.
 *
 * ⚠️ 그 왕복을 없애는 조건은 **「매핑이 shared로 올라오는 때」 하나**이고, 그때는 **이 화면과
 * 선례 둘 다** 바뀐다 — 한 자리만 고치면 두 화면의 판정이 갈린다(그 조건·재는 법은 위 JSDoc).
 *
 * ## 선택 병행 팝업 — 「팝업으로도 알리기」 (2026-10-29부터 저작한다)
 *
 * 종전 이 절은 「아직 저작할 수 없는 축 — 저작 DTO가 그 칸을 받지 않는다」였고 **그 전제가 바뀌었다**:
 * 서버 공지 DTO가 `popup: { frequency, optOut } | null`을 받고 공지가 팝업 기제를 호출한다(결정
 * `2026-10-26-popup-close-is-a-session-and-opt-out-is-an-option.md` 개정 Q4). 폼의 토글 + 두 옵션이
 * 그 입구이고, 목록의 「팝업 병행」 배지는 그 결과(`popupId`)다. 보내는 키의 갈래(생성 생략 · 수정
 * `null`)는 `formToInput` JSDoc이 정본이다.
 *
 * ## 시각 프리미티브 — 직접 칠하지 않는다
 *
 * 행은 `Card`, 상태 라벨은 `Badge`(`@safetyhub/ui`)다. 로컬 배지를 만들면
 * `local/no-self-painted-badge`가 잡고(연한 tint `<span>`이 그 규칙의 축이다) **그 규칙의 ratchet
 * 숫자가 늘어난다** — admin은 그 예외 목록이 「줄어들기만 해야」 하는 상태다(eslint 설정 주석).
 * 반지름은 역할 토큰(`rounded-control`·`rounded-card-sm`·`rounded-card`)을 쓴다.
 */
import { useEffect, useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Badge, Button, Card, ConfirmModal, Modal, useModalRequestClose } from '@safetyhub/ui';
import { formatDateTimeISO, parseLocalToUTC } from '@safetyhub/shared';
import { extractApiError } from '../lib/api';
import { useToastStore } from '../stores/toast';
import { useAudienceOptions, audienceLabel, splitUnlistedAudiences } from '../lib/audience-options';
import OrgTargetCombobox from '../components/OrgTargetCombobox';
import {
  ADMIN_ANNOUNCEMENT_QUERY_KEYS,
  ANNOUNCEMENT_ORG_SCOPES,
  ANNOUNCEMENT_ORG_SCOPE_LABELS,
  ANNOUNCEMENT_POPUP_FREQUENCY_LABELS,
  ANNOUNCEMENT_POPUP_OPT_OUT_LABELS,
  ANNOUNCEMENT_SURFACES,
  ANNOUNCEMENT_SURFACE_LABELS,
  ANNOUNCEMENT_UNCONSTRAINED_CODE,
  DEFAULT_ANNOUNCEMENT_POPUP_OPTIONS,
  adminAnnouncementsApi,
  type AdminAnnouncement,
  type AnnouncementAuthoringInput,
  type AnnouncementOrgScope,
  type AnnouncementPopupOptionsInput,
  type AnnouncementSurface,
} from '../lib/announcements';

/**
 * 조직 타깃 상한 — 서버 DTO의 `MAX_ORG_TARGETS`와 **같은 값**이다.
 *
 * ⚠️ 서버에서 가져올 길이 없어(그 상수는 서버 DTO 파일에 산다) 손으로 맞춘다. 어긋나는 방향은
 * 둘이고 **둘 다 시끄럽다**: 여기가 크면 서버 `@ArrayMaxSize`가 400을 내고, 작으면 운영자가 더
 * 고를 수 없다(그때 화면이 왜 멈추는지 말한다). 서버 쪽 주석이 「정책 상한이 아니라 payload
 * 상한」이라 적으므로 이 수가 정책을 뜻하지 않는다.
 */
const MAX_ORG_TARGETS = 500;

/** 폼 컨트롤 공통 클래스 — 반지름은 역할 토큰(`rounded-control`, 목업 `.btn`·`.search`와 같은 층) */
const FIELD_CLS =
  'w-full text-sm border border-gray-300 rounded-control px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-400';

/** 저작 폼이 들고 있는 상태 — 날짜는 `datetime-local` 원문(현지)이고 UTC 변환은 제출 때 한다. */
interface FormState {
  title: string;
  body: string;
  platforms: AnnouncementSurface[];
  audiences: string[];
  orgScope: AnnouncementOrgScope;
  targetOrganizationIds: string[];
  pinned: boolean;
  /** `datetime-local` 원문 — 빈 문자열이면 「하한 없음」 */
  startsAtLocal: string;
  endsAtLocal: string;
  publish: boolean;
  hidden: boolean;
  /** 「팝업으로도 알리기」 — 켜져 있으면 아래 두 옵션을 보낸다(개정 Q4) */
  popupEnabled: boolean;
  popupOptions: AnnouncementPopupOptionsInput;
}

const POPUP_FREQUENCIES = Object.keys(
  ANNOUNCEMENT_POPUP_FREQUENCY_LABELS,
) as AnnouncementPopupOptionsInput['frequency'][];
const POPUP_OPT_OUTS = Object.keys(
  ANNOUNCEMENT_POPUP_OPT_OUT_LABELS,
) as AnnouncementPopupOptionsInput['optOut'][];

/** 저장된 값(열린 와이어 문자열) → 폼 값. 모르는 값은 기본값으로 떨어뜨린다 */
function toPopupOptions(
  stored: { frequency: string; optOut: string } | null | undefined,
): AnnouncementPopupOptionsInput {
  const frequency = POPUP_FREQUENCIES.find((v) => v === stored?.frequency);
  const optOut = POPUP_OPT_OUTS.find((v) => v === stored?.optOut);
  return {
    frequency: frequency ?? DEFAULT_ANNOUNCEMENT_POPUP_OPTIONS.frequency,
    optOut: optOut ?? DEFAULT_ANNOUNCEMENT_POPUP_OPTIONS.optOut,
  };
}

const EMPTY_FORM: FormState = {
  title: '',
  body: '',
  platforms: [],
  audiences: [],
  orgScope: 'ALL',
  targetOrganizationIds: [],
  pinned: false,
  startsAtLocal: '',
  endsAtLocal: '',
  publish: false,
  hidden: false,
  popupEnabled: false,
  popupOptions: DEFAULT_ANNOUNCEMENT_POPUP_OPTIONS,
};

/**
 * 저장된 UTC ISO → `datetime-local` 입력값.
 *
 * ⚠️ `formatDateTimeISO`는 **현지(기본 Asia/Seoul)** 로 포맷한다(CLAUDE.md 시간대 정책: 내부는 UTC ·
 * 표시·입력은 현지). 그 반대 변환이 `parseLocalToUTC`이고 둘이 **짝**이다 — 한쪽만 바꾸면 저장할
 * 때마다 9시간씩 밀린다.
 */
function toLocalInput(iso: string | null): string {
  if (!iso) return '';
  return formatDateTimeISO(new Date(iso));
}

/** 현지 원문 → UTC ISO. 빈 문자열은 null(기간 없음)이고 **불완전한 입력은 던진다**(호출부가 막는다) */
function toUtcIso(local: string): string | null {
  if (!local) return null;
  return parseLocalToUTC(local).toISOString();
}

/**
 * 폼 → 요청 body. **생성·수정이 보내는 키가 다르다** — `isUpdate`로 가른다.
 *
 * ⚠️ `hidden`은 **수정에만** — 생성 DTO에 그 칸이 없어 실으면 400이다(`AnnouncementAuthoringInput.hidden`
 * JSDoc). ⚠️ 끈 「팝업으로도 알리기」는 **생성이면 생략 · 수정이면 `null`**이다 — 수정에서 생략하면
 * 서버가 「유지」로 읽어 끈 토글이 적용되지 않는다(서버 `UpdateAnnouncementDto.popup` JSDoc).
 */
function formToInput(form: FormState, isUpdate: boolean): AnnouncementAuthoringInput {
  return {
    title: form.title.trim(),
    body: form.body,
    platforms: form.platforms,
    audiences: form.audiences,
    orgScope: form.orgScope,
    // ⚠️ `ALL`이면 **반드시 빈 배열**이다 — 서버가 짝을 보고 `ANNOUNCEMENT_ORG_TARGETS_NOT_ALLOWED`를
    //    낸다. 화면이 모드를 바꿀 때 목록을 비우지만, 제출 시점에도 한 번 더 좁혀 「라디오는 ALL인데
    //    목록이 남은」 상태가 요청에 실리지 않게 한다(둘 중 하나가 빠져도 조합이 안 생긴다).
    targetOrganizationIds: form.orgScope === 'ALL' ? [] : form.targetOrganizationIds,
    pinned: form.pinned,
    startsAt: toUtcIso(form.startsAtLocal),
    endsAt: toUtcIso(form.endsAtLocal),
    publish: form.publish,
    ...(isUpdate ? { hidden: form.hidden } : {}),
    ...(form.popupEnabled ? { popup: form.popupOptions } : isUpdate ? { popup: null } : {}),
  };
}

function itemToForm(item: AdminAnnouncement): FormState {
  return {
    title: item.title,
    body: item.body,
    platforms: item.platforms,
    audiences: item.audiences,
    orgScope: item.orgScope,
    targetOrganizationIds: item.orgTargets.map((t) => t.organizationId),
    pinned: item.pinned,
    startsAtLocal: toLocalInput(item.startsAt),
    endsAtLocal: toLocalInput(item.endsAt),
    publish: item.publishedAt !== null,
    hidden: item.hidden,
    // 「켜져 있다」의 근거는 `popupId`다 — `popup`은 목록이 함께 싣는 옵션 **값**이다
    popupEnabled: item.popupId !== null,
    popupOptions: toPopupOptions(item.popup),
  };
}

/** 사람이 읽는 시각 — 목록 표시용. 기간이 없으면 「—」 */
function displayTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('ko-KR', { dateStyle: 'medium', timeStyle: 'short' });
}

export default function Announcements() {
  const queryClient = useQueryClient();
  const { showToast } = useToastStore();
  const [editing, setEditing] = useState<{ item: AdminAnnouncement | null } | null>(null);
  const [deleting, setDeleting] = useState<AdminAnnouncement | null>(null);

  const list = useQuery({
    queryKey: ADMIN_ANNOUNCEMENT_QUERY_KEYS.list,
    queryFn: () => adminAnnouncementsApi.list(),
  });

  // 칩 라벨 해소 — 목록은 모달과 무관하게 떠 있으므로 상시 조회한다(선례 `ReleaseNotes`).
  const { groups: audienceGroups } = useAudienceOptions(true);

  const removeMutation = useMutation({
    mutationFn: (id: string) => adminAnnouncementsApi.remove(id),
    onSuccess: () => {
      showToast('공지를 삭제했습니다.', 'success');
      setDeleting(null);
      queryClient.invalidateQueries({ queryKey: ADMIN_ANNOUNCEMENT_QUERY_KEYS.list });
    },
    onError: (error) => showToast(extractApiError(error).message, 'error'),
  });

  const items = list.data ?? [];

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">전사 공지</h1>
          <p className="mt-1 text-sm text-gray-500">
            전 고객(또는 고른 조직)에게 보이는 공지입니다. 초안·숨김·기간이 지난 것까지 전부
            보입니다.
          </p>
        </div>
        <Button variant="primary" size="sm" onClick={() => setEditing({ item: null })}>
          새 공지
        </Button>
      </div>

      {list.isLoading ? (
        <div className="py-12 text-center text-gray-500">불러오는 중...</div>
      ) : list.error ? (
        <div className="p-3 bg-red-50 border border-red-200 rounded-card text-sm text-red-700">
          공지 목록을 불러오지 못했습니다. {extractApiError(list.error).message}
        </div>
      ) : items.length === 0 ? (
        <div className="py-12 text-center text-gray-500">
          아직 전사 공지가 없습니다. 「새 공지」로 만드세요.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => (
            <AnnouncementRow
              key={item.id}
              item={item}
              audienceGroups={audienceGroups}
              onEdit={() => setEditing({ item })}
              onDelete={() => setDeleting(item)}
            />
          ))}
        </div>
      )}

      {editing && (
        <AnnouncementFormModal
          /*
            ⚠️ `key`로 **구조적 remount**를 보장한다 — 폼 상태가 `useState(initial)`이라 인스턴스가
            살아 있으면 초기값이 갱신되지 않는다. 지금은 모달이 열려 있을 때 다른 행의 「수정」을
            누를 수 없어(오버레이가 가린다) 늘 `null`을 거치지만, 그 **UI 사실에 기대는 것**은
            버튼을 하나 옮기는 날 조용히 깨진다(다른 공지의 입력이 이 공지에 저장된다).
            선례 `ReleaseNoteAudienceModal`은 같은 위험을 effect 재동기화로 막는데, remount가
            「어느 값을 다시 읽어야 하나」를 열거하지 않아도 되므로 더 좁다.
          */
          key={editing.item?.id ?? 'new'}
          item={editing.item}
          onClose={() => setEditing(null)}
          onSaved={() => {
            setEditing(null);
            queryClient.invalidateQueries({ queryKey: ADMIN_ANNOUNCEMENT_QUERY_KEYS.list });
          }}
        />
      )}

      <ConfirmModal
        open={deleting !== null}
        danger
        title="공지를 삭제합니다"
        body={
          <>
            <p className="font-medium">{deleting?.title}</p>
            {/*
              ⚠️ 무엇이 함께 사라지는지 말한다 — 「봤음」 기록은 FK CASCADE가 지우므로(서버 컨트롤러
              JSDoc) 되살릴 수 없다. 숨기는 것으로 충분하면 삭제가 아니라 **숨김**이 그 수단이다.
            */}
            <p className="mt-2 text-sm text-gray-600">
              이 공지와 「봤음」 기록·대상 조직 목록이 함께 지워지며 되살릴 수 없습니다. 노출만
              멈추려면 삭제가 아니라 수정에서 <strong>숨김</strong>을 켜세요.
            </p>
          </>
        }
        confirmLabel="삭제"
        busy={removeMutation.isPending}
        onConfirm={() => deleting && removeMutation.mutate(deleting.id)}
        onClose={() => setDeleting(null)}
      />
    </div>
  );
}

/**
 * 목록의 한 행.
 *
 * ⚠️ **게시 상태·숨김·기간을 «한 배지»로 합치지 않는다** — 스키마가 「숨김은 기간·게시와 **독립**」
 * 이라 적는다. 합치면 「숨김인데 게시됨」·「게시인데 기간 밖」 같은 실제 상태가 **표현되지 않아**
 * 운영자가 왜 안 보이는지 알 수 없다.
 */
function AnnouncementRow({
  item,
  audienceGroups,
  onEdit,
  onDelete,
}: {
  item: AdminAnnouncement;
  audienceGroups: ReturnType<typeof useAudienceOptions>['groups'];
  onEdit: () => void;
  onDelete: () => void;
}) {
  /**
   * ⚠️ 아래 「예약」·「기간 지남」 배지는 **렌더 시점 판정**이다 — 노출 판정의 정본은 서버다.
   *
   * 이 목록 쿼리에 `refetchInterval`이 **없으므로**(admin에서 그것을 쓰는 자리는
   * `hooks/useFeatureFlags.ts`·`pages/Operations.tsx`뿐이다) 페이지를 열어 둔 채 `startsAt`·
   * `endsAt`을 지나면 배지가 **조용히 낡는다**. 값은 서버가 준 것이 맞고 **라벨만 거짓이 되는**
   * 종류라 tsc·spec이 원리적으로 못 잡는다.
   *
   * ⚠️ 그래서 폴링을 **두지 않았다** — 저작 화면이고 배지는 참고 표시라 피해가 작다(뷰어 쪽 노출은
   * 서버가 매 요청 판정한다). 되짚을 조건: 이 배지를 보고 **운영 판단을 하게 되면**(「지났으니
   * 지워도 된다」류) 그때 폴링이나 「방금 기준」 표기를 넣는다. 그 전까지 처방은 이 한 줄이다.
   */
  const now = Date.now();
  const notYet = item.startsAt !== null && new Date(item.startsAt).getTime() > now;
  const expired = item.endsAt !== null && new Date(item.endsAt).getTime() < now;

  return (
    <Card>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h2 className="font-medium text-gray-900 break-words">{item.title}</h2>
            {item.publishedAt === null ? (
              <Badge tone="slate" size="sm">
                초안
              </Badge>
            ) : (
              <Badge tone="emerald" size="sm">
                게시
              </Badge>
            )}
            {item.hidden && (
              <Badge tone="slate" size="sm">
                숨김
              </Badge>
            )}
            {notYet && (
              <Badge tone="amber" size="sm">
                예약
              </Badge>
            )}
            {expired && (
              <Badge tone="amber" size="sm">
                기간 지남
              </Badge>
            )}
            {item.pinned && (
              <Badge tone="brand" size="sm">
                고정 띠
              </Badge>
            )}
            {/* 「팝업으로도 알리기」가 켜진 공지 — 옵션은 수정 폼이 보인다(이 파일 docblock의 그 절) */}
            {item.popupId && (
              <Badge tone="violet" size="sm">
                팝업 병행
              </Badge>
            )}
          </div>
          <p className="mt-1 text-sm text-gray-600 whitespace-pre-wrap line-clamp-3">{item.body}</p>
        </div>
        <div className="flex gap-1 shrink-0">
          <Button variant="secondary" size="sm" onClick={onEdit}>
            수정
          </Button>
          <Button variant="secondary" size="sm" onClick={onDelete}>
            삭제
          </Button>
        </div>
      </div>

      <dl className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-xs">
        <Field label="노출 화면">
          {/*
            ⚠️ 빈 배열은 **결함**이다(스키마 JSDoc — 아무에게도 안 보이는데 저장은 성공한다).
            빨갛게 말한다 — 선례 `ReleaseNotes`의 `platforms` 처리와 같은 자세.
            ⚠️ 저작 DTO가 `@ArrayMinSize(1)`로 막으므로 이 상태는 **이 화면으로는 만들 수 없다**.
            그래도 그리는 이유는 DB 직접 쓰기·옛 행이 그 모양일 수 있고, 그때 **왜 안 보이는지**를
            이 줄만 보고 알 수 있어야 하기 때문이다.
          */}
          {item.platforms.length === 0 ? (
            <span className="text-red-600 font-medium">(없음 — 아무에게도 보이지 않습니다)</span>
          ) : (
            item.platforms.map((p) => (
              <Badge key={p} tone="slate" size="sm" shape="rounded">
                {ANNOUNCEMENT_SURFACE_LABELS[p] ?? p}
              </Badge>
            ))
          )}
        </Field>

        <Field label="조직 범위">
          <span className="text-gray-700">{ANNOUNCEMENT_ORG_SCOPE_LABELS[item.orgScope]}</span>
          {item.orgScope !== 'ALL' && (
            <span className="text-gray-500">({item.orgTargets.length}개 조직)</span>
          )}
        </Field>

        <Field label="노출 대상 역할">
          {/*
            ⚠️ **빈 배열의 뜻이 `platforms`와 반대다** — 여기서 빈 배열은 「모두에게」(정상·기본값)다.
            두 칸을 같은 눈으로 보면 하나는 거짓 경고가 되고 하나는 진짜 결함을 놓친다.
            라벨 해소는 `audienceLabel`이 하고 후보에 없는 참조는 **raw 값 그대로** 보인다.
          */}
          {item.audiences.length === 0 ? (
            <span className="text-gray-500">모두에게</span>
          ) : (
            item.audiences.map((ref) => (
              <Badge key={ref} tone="violet" size="sm" shape="rounded">
                {audienceLabel(ref, audienceGroups)}
              </Badge>
            ))
          )}
        </Field>

        <Field label="노출 기간">
          <span className="text-gray-700">
            {displayTime(item.startsAt)} ~ {displayTime(item.endsAt)}
          </span>
        </Field>
      </dl>
    </Card>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex items-baseline gap-2">
      <dt className="shrink-0 text-gray-400">{label}</dt>
      <dd className="flex flex-wrap items-center gap-1 min-w-0">{children}</dd>
    </div>
  );
}

/**
 * 생성·수정 폼.
 *
 * base `Modal`(`@safetyhub/ui`)을 쓴다 — admin 자체 base는 2026-10-30에 삭제됐다(경위는
 * `ReleaseNoteAudienceModal` docblock).
 *
 * ⚠️ 수정도 **전량**을 보낸다(부분 전송 아님). 특히 `orgScope`와 타깃은 **함께 보내야** 서버의
 * `ANNOUNCEMENT_ORG_SCOPE_CHANGE_NEEDS_TARGETS`에 걸리지 않는다 — 모드만 바꾸면 옛 목록이 새 모드의
 * 뜻으로 재해석되어 **노출 대상이 뒤집힌다**(`INCLUDE [orgA]` → `EXCLUDE`면 「orgA만」이 「orgA만
 * 빼고 전부」가 된다).
 */
function AnnouncementFormModal({
  item,
  onClose,
  onSaved,
}: {
  item: AdminAnnouncement | null;
  onClose: () => void;
  onSaved: () => void;
}) {
  const { showToast } = useToastStore();
  const initial = useMemo(() => (item ? itemToForm(item) : EMPTY_FORM), [item]);
  const [form, setForm] = useState<FormState>(initial);
  const [saving, setSaving] = useState(false);

  /**
   * 서버가 승인을 요구한 상태 — `ANNOUNCEMENT_AUDIENCE_NAMESPACE_UNCONSTRAINED`의 메시지를 담는다.
   *
   * ⚠️ **클라이언트가 미리 판정하지 않는 이유는 이 파일 docblock과 `lib/announcements.ts`의
   * `ANNOUNCEMENT_UNCONSTRAINED_CODE` JSDoc이 정본**이다(매핑이 서버에만 있다). 그래서 흐름은
   * 「저장 → 400 → 그 메시지 + 승인란 → 재전송」이다. **막다른 길이 아니다** — 회복 경로가 화면에
   * 있고 메시지가 **어느 체계인지 이름 들어** 말한다.
   *
   * ⚠️ 메시지를 **파싱해 번역하지 않는다**. 서버가 네임스페이스를 개발 어휘 날것(`company`·`sa`)으로
   * 적는 것은 알지만, 문구를 파싱하면 서버가 말을 다듬는 날 조용히 깨진다 — 그 축의 소유자는 서버
   * 문자열이다.
   */
  const [ackDemand, setAckDemand] = useState<string | null>(null);
  const [acknowledged, setAcknowledged] = useState(false);

  /**
   * 노출 축이 바뀌면 승인을 **반드시 풀고 요구도 지운다**(fail-closed).
   *
   * 「`WEB`+company만 고르고 승인 → `ADMIN`을 더하기」처럼 축을 옮기면 승인의 **대상이 달라지므로**,
   * 남겨 두면 운영자가 보지 않은 조합에 승인이 실린다. 선례 `ReleaseNoteAudienceModal`의 같은 축
   * (그쪽은 역할 선택만 보지만 이 화면은 `platforms`도 판정에 든다 — 서버가 **둘의 조합**으로
   * 판정하므로 둘 다 dep이어야 한다).
   *
   * ⚠️ 배열 **참조**를 dep으로 쓰지 않는다 — 매 렌더 새 참조일 수 있어 이 effect가 매번 돌면
   * 운영자가 방금 체크한 승인이 즉시 풀린다. 그래서 **값**으로 묶어 비교한다(선례의 같은 주석).
   */
  const exposureKey = `${[...form.platforms].sort().join(',')}|${[...form.audiences].sort().join(',')}`;
  useEffect(() => {
    setAcknowledged(false);
    setAckDemand(null);
  }, [exposureKey]);

  const togglePlatform = (platform: AnnouncementSurface) => {
    setForm((prev) => ({
      ...prev,
      platforms: prev.platforms.includes(platform)
        ? prev.platforms.filter((p) => p !== platform)
        : [...prev.platforms, platform],
    }));
  };

  const toggleAudience = (ref: string) => {
    setForm((prev) => ({
      ...prev,
      audiences: prev.audiences.includes(ref)
        ? prev.audiences.filter((r) => r !== ref)
        : [...prev.audiences, ref],
    }));
  };

  /**
   * ⭐ **가드 ③④를 화면이 선제 차단한다** — `ADMIN` surface와 조직 축은 **다른 축**이고 교차의
   * 뜻이 규약으로 정해지지 않는다(서버 `assertAdminPlatformCombination` JSDoc: 「그 모호함을 해석으로
   * 고르지 않고 **표현 불가**로 만든다」).
   *
   * ⚠️ 차단을 **양방향으로** 걸고 **상대 선택을 조용히 바꾸지 않는다** — 한쪽을 고르면 다른 쪽을
   * 비활성으로 두고 **왜인지** 말한다. 자동으로 되돌리면 운영자가 방금 고른 것이 사라져 그 이유를
   * 알 수 없다. 둘 다 원하면 **공지를 둘로** 쓴다(서버 JSDoc의 처방과 같다).
   *
   * ⚠️ **이 가드는 매핑이 필요 없다** — 두 값만 본다. 그래서 다른 두 가드와 달리 화면이 소유할 수
   * 있고, 소유하는 쪽이 낫다(서버 400을 보기 전에 조합이 안 생긴다).
   */
  const adminSelected = form.platforms.includes('ADMIN');
  const orgTargetingSelected = form.orgScope !== 'ALL';

  const setOrgScope = (orgScope: AnnouncementOrgScope) => {
    setForm((prev) => ({
      ...prev,
      orgScope,
      // `ALL`로 돌아가면 목록을 비운다 — 서버가 짝을 보고 `..._TARGETS_NOT_ALLOWED`를 낸다(가드 ⑤).
      targetOrganizationIds: orgScope === 'ALL' ? [] : prev.targetOrganizationIds,
    }));
  };

  /** 입력이 불완전한 날짜·시각인가 — `datetime-local`은 타이핑 도중 `2026-10` 같은 값을 준다 */
  const dateError = useMemo(() => {
    for (const [label, raw] of [
      ['노출 시작', form.startsAtLocal],
      ['노출 종료', form.endsAtLocal],
    ] as const) {
      if (!raw) continue;
      try {
        parseLocalToUTC(raw);
      } catch {
        return `${label} 일시가 올바르지 않습니다.`;
      }
    }
    return null;
  }, [form.startsAtLocal, form.endsAtLocal]);

  /**
   * 「노출 창이 비었다」 — **2026-10-20부터 차단이다**(종전엔 경고였다).
   *
   * ## ⚠️ 종전 주석의 근거가 «사라졌다» — 그래서 처분이 뒤집혔다
   *
   * 종전 이 자리는 「경고이고 차단이 아니다 — **서버에 이 가드가 없다**(2026-10-20 확인). 여기서
   * 막으면 **화면이 막는데 서버는 허용**하는 상태가 되고 그쪽이 더 나쁘다」라 적고 있었다. 그
   * 판단은 **그때 참이었다** — 비대칭의 방향이 그랬기 때문이다.
   *
   * 같은 날 서버가 그 가드를 가졌다(`ANNOUNCEMENT_PERIOD_EMPTY` —
   * `announcement-authoring.service.ts`의 `assertExposurePeriod`) ⇒ **경고로 두면 이제 반대 비대칭**
   * 이 된다: 화면은 「저장할 수 있다」는데 서버가 400을 내고, 그 400은 토스트로만 보인다. 저장
   * 전에 아는 편이 낫다(값 둘만 비교하면 되어 **서버 상태가 필요 없다**).
   *
   * ## ⚠️ `>` 가 아니라 `>=` 다 — 서버의 노출 창이 **반개구간**이다
   *
   * 뷰어 쿼리가 `startsAt lte now` ∧ `endsAt gt now`로 좁히므로 두 값이 **같으면 창의 길이가 0**
   * 이고 아무에게도 보이지 않는다(판정 정본은 서버 `common/utils/exposure-period.util.ts`의
   * `isEmptyExposureWindow`). 종전 `>`는 **같음을 통과시켰고** 그러면 그 입력만 서버에서 400이
   * 된다 ⇒ 두 자리가 **같은 경계**를 써야 한다.
   *
   * ⚠️ **그 경계는 서버가 소유한다.** 여기 숫자·부등호를 고치려면 그 유틸을 먼저 보라 — 두 자리가
   * 갈리면 「화면은 막는데 서버는 허용」 또는 그 반대가 되고 **어느 검사도 red가 아니다**(admin은
   * 그 유틸을 import할 수 없다 — 서버 패키지다).
   */
  const periodEmpty = useMemo(() => {
    if (dateError || !form.startsAtLocal || !form.endsAtLocal) return false;
    try {
      return parseLocalToUTC(form.startsAtLocal) >= parseLocalToUTC(form.endsAtLocal);
    } catch {
      return false;
    }
  }, [dateError, form.startsAtLocal, form.endsAtLocal]);

  const missingRequired =
    form.title.trim().length === 0 || form.body.trim().length === 0 || form.platforms.length === 0;

  /** `INCLUDE`·`EXCLUDE`인데 목록이 비면 서버가 `..._TARGETS_REQUIRED`를 낸다(가드 ⑤) — 여기서 막는다 */
  const missingTargets = orgTargetingSelected && form.targetOrganizationIds.length === 0;

  const blockedReason = missingRequired
    ? '제목·내용·노출 화면은 필수입니다.'
    : missingTargets
      ? '조직 범위를 좁혔으면 대상 조직을 최소 하나 고르세요.'
      : dateError
        ? dateError
        : periodEmpty
          ? '노출 종료를 시작보다 뒤로 두세요 — 그 기간에는 아무에게도 보이지 않습니다.'
          : ackDemand !== null && !acknowledged
          ? '아래 확인란을 체크하거나 그 체계의 역할을 고르세요.'
          : undefined;

  /**
   * 저장하지 않은 변경이 있나 — base `Modal`의 dirty 닫기 보호 입력.
   *
   * ⚠️ 배열은 **집합으로** 비교한다(정렬 후). 고른 **순서**는 저장값의 의미가 아니므로
   * (서버는 `text[]`에 받은 순서대로 쓰지만 판정은 `some`·`has`다) 순서만 다른 상태를 dirty로
   * 보면 **거짓 확인 모달**이 뜬다 — 체크박스를 껐다 켜기만 해도 「변경사항이 날아갑니다」를
   * 묻게 된다. 선례 `ReleaseNoteAudienceModal`의 `isDirty`가 같은 이유로 같은 처리를 한다.
   */
  const isDirty = useMemo(() => {
    const normalize = (f: FormState) =>
      JSON.stringify({
        ...f,
        platforms: [...f.platforms].sort(),
        audiences: [...f.audiences].sort(),
        targetOrganizationIds: [...f.targetOrganizationIds].sort(),
      });
    return normalize(form) !== normalize(initial);
  }, [form, initial]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const input: AnnouncementAuthoringInput = {
        ...formToInput(form, item !== null),
        // ⚠️ 승인이 필요 없을 때 `false`를 보내지 않는다 — 기본값의 소유자는 서버 하나다
        //    (`lib/announcements.ts`의 그 칸 JSDoc).
        acknowledgeUnconstrainedNamespaces: ackDemand !== null ? acknowledged : undefined,
      };
      if (item) await adminAnnouncementsApi.update(item.id, input);
      else await adminAnnouncementsApi.create(input);
      showToast(item ? '공지를 수정했습니다.' : '공지를 만들었습니다.', 'success');
      onSaved();
    } catch (error) {
      const { code, message } = extractApiError(error);
      // ⚠️ 모달을 **닫지 않는다** — 고친 입력을 잃지 않게(선례 `ReleaseNotes.handleSaveAudiences`).
      if (code === ANNOUNCEMENT_UNCONSTRAINED_CODE) setAckDemand(message);
      showToast(message, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      title={item ? '공지 수정' : '새 전사 공지'}
      size="xl"
      isDirty={isDirty}
      closeLocked={saving}
      // ⚠️ **스크롤은 본문에 건다** — 패널에 걸면 푸터까지 함께 스크롤돼 저장 버튼이 화면 밖으로
      //    밀린다. 역할·조직 목록은 **DB 행**이라 자란다. 그 축은 그대로이고, 2026-10-26에
      //    **그 일을 공용 base가 맡았다** — 종전에는 본문 div에 `max-h-[70vh] overflow-y-auto`를
      //    손으로 걸었고 이제 이 prop이 같은 일을 한다. ⚠️ 상한이 `70vh` → `max-h-full`로
      //    **바뀐다**(오버레이 `p-4` 여백을 base가 한 번만 센다 — 그 계산은 base의
      //    `BODY_SCROLL_PANEL_CLASS` 주석이 정본).
      bodyScroll
      footer={
        <FormFooter
          saving={saving}
          blockedReason={blockedReason}
          onClose={onClose}
          onSave={handleSave}
        />
      }
    >
      {/*
        스크롤은 위 `bodyScroll`이 소유한다 — 그 이유는 그 prop 옆 주석에 있다(여기 다시 적지
        말 것: 두 자리에 적으면 한쪽이 조용히 낡는다). 종전에는 이 div가
        `max-h-[70vh] overflow-y-auto`도 들고 있었다.
        ⚠️ `space-y-5`는 **스크롤 축이 아니다** — 필드 사이 간격이라 그대로 남긴다. 그리고
        여기에 `overflow-y-auto`를 다시 넣지 말 것: base 본문이 이미 스크롤 컨테이너라
        **이중 스크롤**이 된다(그 형태의 선례가 `pages/manual/ManualSearch`다).
      */}
      <div className="space-y-5">
        <label className="block">
          <span className="text-sm font-medium text-gray-700">제목</span>
          <input
            type="text"
            value={form.title}
            maxLength={200}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
            className={`mt-1 ${FIELD_CLS}`}
          />
        </label>

        <label className="block">
          <span className="text-sm font-medium text-gray-700">내용</span>
          <textarea
            value={form.body}
            maxLength={10_000}
            rows={8}
            onChange={(e) => setForm((prev) => ({ ...prev, body: e.target.value }))}
            className={`mt-1 ${FIELD_CLS}`}
          />
          {/* 서식 규약은 스키마 JSDoc이 정본 — 마크다운 전체를 해석하지 않는다(팝업과 같은 규약) */}
          <span className="mt-1 block text-xs text-gray-400">
            줄바꿈은 그대로 보이고 <code>**강조**</code>만 굵게 처리됩니다(마크다운 전체는 해석하지
            않습니다).
          </span>
        </label>

        <fieldset>
          <legend className="text-sm font-medium text-gray-700">노출 화면</legend>
          <div className="mt-1 flex flex-wrap gap-2">
            {ANNOUNCEMENT_SURFACES.map((platform) => {
              // 가드 ③④ — 조직 범위를 좁힌 상태에서는 `ADMIN`을 고를 수 없다(위 JSDoc)
              const lockedByOrgTargeting = platform === 'ADMIN' && orgTargetingSelected;
              return (
                <label
                  key={platform}
                  title={
                    lockedByOrgTargeting
                      ? '조직 범위를 좁힌 공지에는 관리자 페이지를 함께 쓸 수 없습니다. 슈퍼관리자는 조직 축에 들지 않습니다.'
                      : undefined
                  }
                  className={`flex items-center gap-1.5 px-2 py-1 text-sm border rounded-control ${
                    lockedByOrgTargeting
                      ? 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
                      : form.platforms.includes(platform)
                        ? 'border-brand-400 bg-brand-50 text-brand-800 cursor-pointer'
                        : 'border-gray-200 text-gray-700 hover:bg-gray-50 cursor-pointer'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={form.platforms.includes(platform)}
                    disabled={lockedByOrgTargeting}
                    onChange={() => togglePlatform(platform)}
                  />
                  {ANNOUNCEMENT_SURFACE_LABELS[platform]}
                </label>
              );
            })}
          </div>
          <span className="mt-1 block text-xs text-gray-400">
            최소 하나를 골라야 합니다. 아무에게도 보이지 않게 두려면 「게시」를 끄세요(초안).
          </span>
        </fieldset>

        <AudienceSection selected={form.audiences} onToggle={toggleAudience} disabled={saving} />

        <fieldset>
          <legend className="text-sm font-medium text-gray-700">조직 범위</legend>
          <div className="mt-1 space-y-1">
            {ANNOUNCEMENT_ORG_SCOPES.map((scope) => {
              // 가드 ③④의 반대 방향 — `ADMIN`을 고른 상태에서는 범위를 좁힐 수 없다
              const lockedByAdmin = scope !== 'ALL' && adminSelected;
              return (
                <label
                  key={scope}
                  title={
                    lockedByAdmin
                      ? '관리자 페이지에 노출하는 공지는 조직 범위를 좁힐 수 없습니다 — 공지를 둘로 나누어 작성하세요.'
                      : undefined
                  }
                  className={`flex items-center gap-2 text-sm ${
                    lockedByAdmin
                      ? 'text-gray-400 cursor-not-allowed'
                      : 'text-gray-700 cursor-pointer'
                  }`}
                >
                  <input
                    type="radio"
                    name="orgScope"
                    checked={form.orgScope === scope}
                    disabled={lockedByAdmin}
                    onChange={() => setOrgScope(scope)}
                  />
                  {ANNOUNCEMENT_ORG_SCOPE_LABELS[scope]}
                </label>
              );
            })}
          </div>

          {orgTargetingSelected && (
            <div className="mt-2">
              <OrgTargetCombobox
                value={form.targetOrganizationIds}
                onChange={(ids) => setForm((prev) => ({ ...prev, targetOrganizationIds: ids }))}
                disabled={saving}
                max={MAX_ORG_TARGETS}
              />
              {/*
                ⚠️ `EXCLUDE`의 뜻을 말한다 — 「고른 조직 빼고 전부」는 **앞으로 생길 조직도 포함**
                한다. 전 조직을 열거하는 것과 다른 상태이고, 그 차이가 조직이 늘 때 드러난다
                (서버 `MAX_ORG_TARGETS` JSDoc: 「전부 열거하는 것은 조직이 늘면 조용히 낡는다」).
              */}
              {form.orgScope === 'EXCLUDE' && (
                <p className="mt-1 text-xs text-gray-500">
                  고른 조직을 뺀 <strong>나머지 전부</strong>에게 보입니다 — 앞으로 새로 생기는
                  조직도 포함됩니다.
                </p>
              )}
            </div>
          )}
        </fieldset>

        <fieldset>
          <legend className="text-sm font-medium text-gray-700">노출 기간</legend>
          <div className="mt-1 grid grid-cols-1 sm:grid-cols-2 gap-2">
            <label className="block">
              <span className="text-xs text-gray-500">시작(비우면 제한 없음)</span>
              <input
                type="datetime-local"
                value={form.startsAtLocal}
                onChange={(e) => setForm((prev) => ({ ...prev, startsAtLocal: e.target.value }))}
                className={`mt-0.5 ${FIELD_CLS}`}
              />
            </label>
            <label className="block">
              <span className="text-xs text-gray-500">종료(비우면 제한 없음)</span>
              <input
                type="datetime-local"
                value={form.endsAtLocal}
                onChange={(e) => setForm((prev) => ({ ...prev, endsAtLocal: e.target.value }))}
                className={`mt-0.5 ${FIELD_CLS}`}
              />
            </label>
          </div>
          <span className="mt-1 block text-xs text-gray-400">
            기간이 지나도 <strong>목록에는 남습니다</strong>(지난 공지를 다시 볼 수 있어야 하므로).
            사라지는 것은 고정 띠·팝업 노출입니다.
          </span>
          {dateError && <p className="mt-1 text-xs text-red-600">{dateError}</p>}
          {/*
            ⚠️ **색이 amber에서 red로 바뀐 것이 의미다** — 이제 **저장이 막힌다**(위 `periodEmpty`
            JSDoc: 서버가 같은 입력을 400으로 거부하므로 경고로 두면 반대 비대칭이 된다). amber로
            되돌리면 「저장은 되는데 노출만 안 된다」로 읽혀 **차단 상태와 어긋난다**.
            ⚠️ 「늦습니다」가 아니라 「빠르거나 같습니다」다 — 경계가 반개구간이라 **같은 값도** 빈 창이다.
          */}
          {periodEmpty && (
            <p className="mt-1 text-xs text-red-600">
              노출 종료가 시작보다 빠르거나 같습니다 — 그 기간에는{' '}
              <strong>아무에게도 보이지 않습니다</strong>. 종료를 시작보다 뒤로 두세요.
            </p>
          )}
        </fieldset>

        <div className="space-y-2">
          <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              className="mt-0.5"
              checked={form.pinned}
              onChange={(e) => setForm((prev) => ({ ...prev, pinned: e.target.checked }))}
            />
            <span>
              목록 위 <strong>고정 띠</strong>로 올린다
              {/*
                배너 상한 2 규약(결정 `2026-08-19-banner-slot-policy-and-actionable-items`) — 서버는
                후보만 주고 상한·접힘은 **화면이** 적용한다. 새 슬롯을 만들지 않는다.
              */}
              <span className="block text-xs text-gray-400">
                띠 자리는 배너 2칸과 경쟁합니다 — 띠가 여럿이면 접힌 한 줄로 보입니다.
              </span>
            </span>
          </label>

          <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              className="mt-0.5"
              checked={form.publish}
              onChange={(e) => setForm((prev) => ({ ...prev, publish: e.target.checked }))}
            />
            <span>
              지금 <strong>게시</strong>한다
              <span className="block text-xs text-gray-400">
                끄면 초안입니다 — 목록에도 띠에도 들지 않습니다. 예약 게시는 위 「시작」이 합니다.
              </span>
            </span>
          </label>

          {/*
            숨김은 **수정에서만** 보인다 — 생성 시점에 「숨김으로 만든다」는 초안과 구별되지 않고
            (둘 다 안 보인다) 칸을 둘 주면 운영자가 어느 것이 무슨 뜻인지 묻게 된다. 스키마는
            둘을 독립 축으로 두지만 **저작 순서**로는 숨김이 「게시한 것을 내린다」의 수단이다.
          */}
          {item && (
            <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
              <input
                type="checkbox"
                className="mt-0.5"
                checked={form.hidden}
                onChange={(e) => setForm((prev) => ({ ...prev, hidden: e.target.checked }))}
              />
              <span>
                <strong>숨김</strong> — 게시·기간과 무관하게 내려 둔다
                <span className="block text-xs text-gray-400">
                  삭제와 다릅니다. 숨김은 되돌릴 수 있고 「봤음」 기록도 남습니다.
                </span>
              </span>
            </label>
          )}
        </div>

        {/*
          「팝업으로도 알리기」(결정 2026-10-26 개정 Q4) — 팝업은 이 공지의 **거울**이라(제목·내용·노출
          화면·대상 역할·조직 범위·기간·게시·숨김을 그대로 받는다) 여기서 고르는 것은 팝업에만 있는 두 축
          뿐이다. 그 축의 뜻은 결정 기록의 ⓐ 표가 정본이다. 끄고 저장하면 연결 팝업이 **지워진다**.
        */}
        <fieldset>
          <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              className="mt-0.5"
              checked={form.popupEnabled}
              onChange={(e) => setForm((prev) => ({ ...prev, popupEnabled: e.target.checked }))}
            />
            <span>
              <strong>팝업</strong>으로도 알리기
              <span className="block text-xs text-gray-400">
                대상자가 접속할 때 이 공지를 팝업으로 한 번 더 띄웁니다.
              </span>
            </span>
          </label>
          {form.popupEnabled && (
            <div className="mt-2 ml-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div role="radiogroup" aria-label="다시 띄우기">
                <span className="text-xs font-medium text-gray-500">다시 띄우기</span>
                {POPUP_FREQUENCIES.map((value) => (
                  <label key={value} className="mt-1 flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                    <input
                      type="radio"
                      name="popupFrequency"
                      checked={form.popupOptions.frequency === value}
                      onChange={() =>
                        setForm((prev) => ({
                          ...prev,
                          popupOptions: { ...prev.popupOptions, frequency: value },
                        }))
                      }
                    />
                    {ANNOUNCEMENT_POPUP_FREQUENCY_LABELS[value]}
                  </label>
                ))}
              </div>
              <div role="radiogroup" aria-label="보는 사람이 끄는 방법">
                <span className="text-xs font-medium text-gray-500">보는 사람이 끄는 방법</span>
                {POPUP_OPT_OUTS.map((value) => (
                  <label key={value} className="mt-1 flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                    <input
                      type="radio"
                      name="popupOptOut"
                      checked={form.popupOptions.optOut === value}
                      onChange={() =>
                        setForm((prev) => ({
                          ...prev,
                          popupOptions: { ...prev.popupOptions, optOut: value },
                        }))
                      }
                    />
                    {ANNOUNCEMENT_POPUP_OPT_OUT_LABELS[value]}
                  </label>
                ))}
              </div>
              {/* 「다시 보지 않기」는 본문을 고쳐도 되살아나지 않는다(결정 개정 Q3) — 그 대가를 고르기 전에 */}
              {form.popupOptions.optOut === 'NEVER_AGAIN' && (
                <p className="sm:col-span-2 text-xs text-gray-500">
                  「다시 보지 않기」를 누른 사람에게는 내용을 고쳐도 다시 뜨지 않습니다. 다시 알려야
                  하면 새 공지를 쓰세요.
                </p>
              )}
            </div>
          )}
        </fieldset>

        {/*
          서버가 승인을 요구한 자리 — 이 파일 docblock의 그 절. 메시지는 **서버 문구 그대로**이고
          어느 체계인지 이름 들어 말한다. 라벨을 「확인했습니다」로만 두지 않는다 — 무엇을 승인하는지
          적지 않으면 고무도장이 된다(선례 `ReleaseNoteAudienceModal`의 같은 자세).
        */}
        {ackDemand !== null && (
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-card text-sm text-amber-800">
            <p>{ackDemand}</p>
            <label className="mt-2 flex items-start gap-2 font-medium cursor-pointer">
              <input
                type="checkbox"
                className="mt-0.5"
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
                disabled={saving}
              />
              <span>위 안내의 체계 전원에게 보여도 됩니다 — 알고 저장합니다.</span>
            </label>
          </div>
        )}
      </div>
    </Modal>
  );
}

/**
 * 노출 대상 역할 — 후보는 `lib/audience-options.ts`가 **두 조회 API**에서 받는다.
 *
 * ⚠️ 그 훅을 쓰는 것이 처방이다(그 파일 docblock: 「공지·팝업도 같은 후보를 쓴다 … 중복이 있으면
 * 이쪽으로 합칠 것」). 후보 목록이 갈리면 「공지에서는 고를 수 있는데 노트에서는 못 고르는」 역할이
 * 생기고 **그 갈라짐에는 red가 없다**.
 *
 * ⚠️ 자유 타이핑을 열지 않는다 — 오타는 **아무에게도 맞지 않는 참조**를 만들고 그 실패는
 * 「안 보인다」라 조용하다(결정 §5). 서버 DTO가 접두 없는 값을 400으로 거부하지만 **역할 key의
 * 실재는 아무도 검증하지 않으므로**(DB 행이다) 오타를 만들지 않는 것이 이 화면의 일이다.
 */
function AudienceSection({
  selected,
  onToggle,
  disabled,
}: {
  selected: string[];
  onToggle: (ref: string) => void;
  disabled: boolean;
}) {
  const { groups, isLoading, hasFailure } = useAudienceOptions(true);

  /**
   * 후보에 없는 저장값 — **「없어진 역할」과 「못 받은 체계의 역할」로 갈라서** 받는다.
   *
   * 판정·사유의 정본은 `lib/audience-options.ts`의 {@link splitUnlistedAudiences} JSDoc 한 벌이다.
   * ⚠️ `!groups.some(…)` 한 줄로 되돌리지 말 것 — 403으로 못 받은 체계의 **정상 제약**이
   * 「제거하세요」 통에 섞여 운영자가 그것을 지운다(노출이 넓어진다). 이 화면과 노출 대상 모달이
   * **같은 파생값**을 읽어야 두 화면의 판정이 갈리지 않는다.
   */
  const unlisted = splitUnlistedAudiences(selected, groups);

  return (
    <fieldset>
      <legend className="text-sm font-medium text-gray-700">노출 대상 역할</legend>

      {hasFailure && (
        /*
          권한 축이 이 화면과 다르다 — 조직 역할은 `system-settings`, 슈퍼관리자 역할은
          `admin-management`를 요구한다(`lib/audience-options.ts`의 그 절). 못 받은 체계는
          **고를 수 없게 둔다**: 자유 타이핑으로 열면 오타가 조용한 오설정이 된다.
        */
        <div className="mt-1 p-3 bg-red-50 border border-red-200 rounded-card text-sm text-red-700">
          일부 역할 목록을 불러오지 못했습니다. 그 체계는 선택할 수 없습니다 — 역할 목록 조회
          권한(조직 역할: 시스템 설정 / 슈퍼관리자 역할: 관리자 관리)이 필요합니다.
        </div>
      )}

      {isLoading ? (
        <div className="mt-1 py-4 text-sm text-gray-500">역할 목록을 불러오는 중...</div>
      ) : (
        <div className="mt-1 space-y-3">
          {groups.map((group) => (
            <div key={group.namespace}>
              <div className="text-xs text-gray-500 mb-1">{group.label}</div>
              {group.failed ? (
                <div className="text-sm text-gray-400">불러오지 못했습니다.</div>
              ) : group.options.length === 0 ? (
                <div className="text-sm text-gray-400">후보 역할이 없습니다.</div>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {group.options.map((opt) => (
                    <label
                      key={opt.ref}
                      className={`flex items-center gap-1.5 px-2 py-1 text-sm border rounded-control cursor-pointer ${
                        selected.includes(opt.ref)
                          ? 'border-brand-400 bg-brand-50 text-brand-800'
                          : 'border-gray-200 text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={selected.includes(opt.ref)}
                        disabled={disabled}
                        onChange={() => onToggle(opt.ref)}
                      />
                      {opt.label}
                    </label>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/*
            후보에 없는 참조 — 조직 커스텀 역할(`co-<cuid>`)·보관된 역할·다른 환경에서 들어온 값이
            그 모양으로 온다. **가리지 않는다**(숨기면 운영자가 「대상이 비어 있다」고 믿는데 서버는
            그 제약으로 거른다). 끄는 것만 할 수 있게 둔다 — 다시 고를 후보가 없으므로.
          */}
          {unlisted.missing.length > 0 && (
            <div>
              <div className="text-xs text-gray-500 mb-1">후보에 없는 대상(보관·조직 전용 역할)</div>
              <div className="flex flex-wrap gap-2">
                {unlisted.missing.map((ref) => (
                  <button
                    key={ref}
                    type="button"
                    disabled={disabled}
                    onClick={() => onToggle(ref)}
                    title="클릭하면 제거합니다"
                    className="px-2 py-1 text-sm border border-gray-300 bg-gray-50 text-gray-600 rounded-control hover:bg-gray-100"
                  >
                    {audienceLabel(ref, groups)} ✕
                  </button>
                ))}
              </div>
            </div>
          )}

          {/*
            ⚠️ **다른 통이다** — 그 체계의 목록을 못 받아(403) 후보에 없어 보이는 것이고, 값 자체는
            정상 제약일 수 있다. 위 통과 섞으면 운영자가 「없어진 역할」로 읽고 지운다 ⇒ 노출이
            넓어진다(사유는 `splitUnlistedAudiences` JSDoc). 그래서 **제거를 막는다**: ✕를 떼고
            버튼을 `disabled`로 둔다. 숨기지도 않는다 — 무엇이 걸려 있는지는 보여야 한다.
          */}
          {unlisted.unloadable.length > 0 && (
            <div>
              <div className="text-xs text-gray-500 mb-1">
                불러오지 못한 체계의 대상(지우지 마세요)
              </div>
              <div className="flex flex-wrap gap-2">
                {unlisted.unloadable.map((ref) => (
                  <button
                    key={ref}
                    type="button"
                    disabled
                    title="역할 목록을 불러오지 못해 이 대상이 유효한지 확인할 수 없습니다 — 제거할 수 없습니다."
                    className="px-2 py-1 text-sm border border-gray-300 bg-gray-50 text-gray-400 rounded-control cursor-not-allowed"
                  >
                    {audienceLabel(ref, groups)}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/*
        빈 선택과 「아무에게도」를 **문구로** 가른다 — 두 축을 섞으면 같은 값이 된다(결정 §6).

        ⚠️ `Card surface="soft"`다 — 직접 칠한 `<div>`(중립 면 + 중립 테두리 + 라운드)는
        `local/no-self-painted-card`가 잡는다(2026-10-20 실측 1건이 정확히 이 줄이었다). 그 규칙
        메시지가 「카드 안 보조 면은 `surface="soft"`+`elevation="none"`」이라 직접 지시한다.
        ⚠️ 위 경고·오류 박스들은 **유채색 테두리**(amber·red)라 그 규칙이 「강조 배너(Callout
        갈래)」로 **일부러 비워 둔** 자리다 — 그래서 `<div>`로 남는다. 둘을 같은 눈으로 보지 말 것.
      */}
      <Card surface="soft" elevation="none" radius="md" padding="sm" className="mt-2 text-xs text-gray-700">
        {selected.length === 0 ? (
          <>
            <strong>고른 화면의 모두에게</strong> 보입니다. 특정 역할에게만 보이려면 위에서
            고르세요(아무에게도 보이지 않게 하려면 「게시」를 끄세요).
          </>
        ) : (
          <>
            <strong>{selected.length}개 역할</strong>에게만 보입니다.
          </>
        )}
      </Card>
    </fieldset>
  );
}

/**
 * 푸터는 **별도 컴포넌트여야 한다** — `useModalRequestClose`는 `Modal` children **하위**에서만 값을
 * 잡는다(부모 본문에서 부르면 `null`이라 dirty 확인이 우회된다). 선례
 * `company-roles/CompanyRoleFormModal.tsx`의 `FormFooter`와 같은 이유다.
 *
 * ⚠️ 취소가 `onClose`를 **직접 부르지 않는다** — `requestClose`를 거쳐야 Esc·오버레이·✕와 **같은
 * 경로**로 수렴해 dirty 확인을 받는다.
 */
function FormFooter({
  saving,
  blockedReason,
  onClose,
  onSave,
}: {
  saving: boolean;
  /**
   * 저장을 막는 사유 — **있으면 곧 비활성**이다(별 `blocked` 플래그를 두지 않는다).
   *
   * ⚠️ 두 값을 따로 받으면 「막혔는데 사유가 없다」·「사유는 있는데 안 막혔다」가 **표현 가능**해지고
   * 그 어긋남은 조용하다(버튼만 보면 왜 비활성인지 알 수 없다). 하나로 묶어 **구조적으로** 맞춘다.
   * `title`로 보이는 이유는 경고 블록이 스크롤 밖일 수 있어서다.
   */
  blockedReason?: string;
  onClose: () => void;
  onSave: () => void;
}) {
  const requestClose = useModalRequestClose();
  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => (requestClose ?? onClose)()}
        disabled={saving}
      >
        취소
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={onSave}
        disabled={saving || blockedReason !== undefined}
        title={blockedReason}
      >
        {saving ? '저장 중...' : '저장'}
      </Button>
    </>
  );
}
